/**
 * Login project catalogue — same org-scoped cache Start Session reads.
 * Written at authentication so Start Session still has eligible projects
 * after the device goes offline, without a prior Time Tracking visit.
 */

import { supabase } from "../supabase";
import { getActiveProjects } from "./projectVisibility";
import { resolveOrganizationIdFromActor } from "./organizationHelpers";
import { loadScopedActiveProjects } from "./operationalQueryAdapters";
import {
  getScopedCachedProjects,
  saveScopedCachedProjects,
} from "./offlineCacheScope";

/** Select shape aligned with Time Tracking Start Session. */
export const BOOTSTRAP_PROJECT_SELECT = `
  project_id,
  project_name,
  created_by,
  client_id,
  organization_id,
  is_active,
  status,
  clients (
    client_name,
    contact_name,
    phone,
    notes
  )
`;

/**
 * Fetch active org-scoped projects and write CP_PROJECTS::{organizationId}.
 * On failure, returns any existing scoped cache and does not clear it.
 */
export async function fetchAndCacheActiveProjects(
  client = supabase,
  actor,
  { directReportIds = [], select = BOOTSTRAP_PROJECT_SELECT } = {},
) {
  if (!client || !actor?.supabase_user_id) {
    return {
      projects: getScopedCachedProjects(actor, directReportIds),
      error: null,
    };
  }

  const organizationId = resolveOrganizationIdFromActor(actor);
  if (!organizationId) {
    const error = new Error(
      "Project catalogue hydration skipped: authenticated actor has no resolved organization.",
    );
    error.code = "PROJECT_CATALOG_ORG_UNRESOLVED";
    return {
      projects: getScopedCachedProjects(actor, directReportIds),
      error,
    };
  }

  try {
    const data = await loadScopedActiveProjects(
      client,
      actor,
      { directReportIds },
      select,
    );
    const activeProjects = getActiveProjects(data || []);
    saveScopedCachedProjects(activeProjects, actor, directReportIds);
    return { projects: activeProjects, error: null };
  } catch (error) {
    console.error("PROJECTS BOOTSTRAP FETCH ERROR:", error);
    return {
      projects: getScopedCachedProjects(actor, directReportIds),
      error,
    };
  }
}
